export const isValidSignature = (signatureKeys: string[], variable: string) => {
	if (!variable.includes('signature_')) return false;

	const normalizedVariable = normalizeSignatureVariable(variable);
	return signatureKeys.some((key) => key === normalizedVariable);
};
	
export const normalizeSignatureVariable = (variable: string) => {
	return variable.replace(/[$,{,}]/g, '').split('signature_')[1];
};